// ============================================================
// API 层：模拟后端接口（返回结构与真实后端一致）
//   res = { state: {type:'SUCCESS'|'ERROE', msg}, data, count }
// 未来接入真实后端时，只需把本文件的实现替换为 axios 调用
// ============================================================
import * as DB from '@/mock/data'

const delay = (ms) => new Promise((r) => setTimeout(r, ms || 200))

const ok = (data, count) => ({ state: { type: 'SUCCESS', msg: '操作成功' }, data, count })
const err = (msg) => ({ state: { type: 'ERROE', msg: msg || '操作失败' } })

// 当前模拟登录用户（demo）
export const getCurrentUser = () => DB.userMap['u-demo']
export const requireLogin = () => {
  if (!localStorage.luffy_jwt_token) throw new Error('NOT_LOGIN')
  return getCurrentUser()
}

const paginate = (list, { page = 1, pagesize = 10 } = {}) => {
  page = Number(page) || 1
  pagesize = Number(pagesize) || 10
  const start = (page - 1) * pagesize
  return { data: list.slice(start, start + pagesize), count: list.length }
}

const filterByLable = (list, lable) => (lable ? list.filter((x) => x.help_lable === lable || x.activity_lable === lable || x.oldstuff_lable === lable || x.job_lable === lable || x.article_lable === lable) : list)
const filterByTag = (list, tag) => (tag ? list.filter((x) => (x.help_tag || '').split(',').includes(tag)) : list)

// ---------------- 公共：分类 / 轮播 ----------------
export const getLable = (lable_name) => delay().then(() => {
  const arr = DB.lables[lable_name] || []
  return ok([{ lable: JSON.stringify(arr) }])
})

export const getCarousels = () => delay().then(() => ok(DB.carousels))

// ---------------- 公共：五类列表 / 详情 ----------------
export const getHelpList = (params) => delay().then(() => {
  let list = DB.helps.filter((h) => h.ispublic === 1)
  list = filterByTag(list, params && params.tag)
  list = filterByLable(list, params && params.lable)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})

export const getHelpContent = (id) => delay().then(() => {
  const h = DB.helps.find((x) => x.help_id === id)
  const u = DB.userMap[h.user_id]
  return ok({ ...h, nickname: u.nickname, avatar: u.avatar, username: u.username, qq: u.qq, mail: u.mail, synopsis: u.synopsis, realstate: u.realstate })
})

export const getActivityList = (params) => delay().then(() => {
  let list = DB.activities.filter((a) => a.ispublic === 1)
  list = filterByLable(list, params && params.lable)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})

export const getActivityContent = (id) => delay().then(() => {
  const a = DB.activities.find((x) => x.activity_id === id)
  const u = DB.userMap[a.user_id]
  return ok({ ...a, nickname: u.nickname, avatar: u.avatar, username: u.username, qq: u.qq, mail: u.mail, synopsis: u.synopsis, realstate: u.realstate })
})

export const getJobList = (params) => delay().then(() => {
  let list = DB.jobs.filter((j) => j.ispublic === 1)
  list = filterByLable(list, params && params.lable)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})

export const getJobContent = (id) => delay().then(() => {
  const j = DB.jobs.find((x) => x.job_id === id)
  const u = DB.userMap[j.user_id]
  return ok({ ...j, nickname: u.nickname, company_name: j.company_name })
})

export const getArticleList = (params) => delay().then(() => {
  let list = DB.articles.filter((a) => a.ispublic === 1)
  list = filterByLable(list, params && params.lable)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})

export const getArticleContent = (id) => delay().then(() => {
  const a = DB.articles.find((x) => x.article_id === id)
  const u = DB.userMap[a.user_id]
  return ok({ ...a, nickname: u.nickname, avatar: u.avatar, username: u.username, qq: u.qq, mail: u.mail, synopsis: u.synopsis, realstate: u.realstate })
})

export const getOldstuffList = (params) => delay().then(() => {
  let list = DB.oldstuffs.filter((o) => o.ispublic === 1)
  list = filterByLable(list, params && params.lable)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})

export const getOldstuffContent = (id) => delay().then(() => {
  const o = DB.oldstuffs.find((x) => x.oldstuff_id === id)
  const u = DB.userMap[o.user_id]
  return ok({ ...o, nickname: u.nickname, avatar: u.avatar, username: u.username, qq: u.qq, phone: u.phone, mail: u.mail, synopsis: u.synopsis, realstate: u.realstate })
})

export const getCompanyList = (params) => delay().then(() => {
  const list = DB.companies.filter((c) => c.company_ispublic === 1)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})

export const getCompanyContent = (id) => delay().then(() => {
  const c = DB.companies.find((x) => x.company_id === id)
  const joblist = DB.jobs.filter((j) => j.company_id === id)
  return ok({ company: c, joblist })
})

// 活动公告
export const getAnnouncementList = (content_id) => delay().then(() => ok(DB.announcements[content_id] || []))

// ---------------- 报名 / 意向 ----------------
export const setJoin = (params) => delay().then(() => {
  const exists = DB.joins.some((j) => j.type === params.type && j.content_id === params.content_id && j.user_id === getCurrentUser().user_id)
  if (exists) return err('你已经报名参加了本项目')
  DB.joins.push({
    join_id: 'jn' + Date.now(), type: params.type, user_id: getCurrentUser().user_id,
    name: params.name || '', describe: params.describe || '', content_id: params.content_id, jions_createtime: Date.now()
  })
  return ok({})
})

// ---------------- 搜索 ----------------
export const searchAll = (keyword) => delay().then(() => {
  const kw = (keyword || '').trim()
  if (!kw) return ok({})
  const match = (s) => (s || '').indexOf(kw) >= 0
  const help = DB.helps.filter((h) => h.ispublic === 1 && (match(h.help_title) || match(h.help_content)))
  const activity = DB.activities.filter((a) => a.ispublic === 1 && (match(a.activity_title) || match(a.activity_content)))
  const job = DB.jobs.filter((j) => j.ispublic === 1 && (match(j.job_name) || match(j.job_content)))
  const company = DB.companies.filter((c) => c.company_ispublic === 1 && (match(c.company_name) || match(c.company_content)))
  const article = DB.articles.filter((a) => a.ispublic === 1 && (match(a.article_title) || match(a.article_content)))
  const oldstuff = DB.oldstuffs.filter((o) => o.ispublic === 1 && (match(o.oldstuff_name) || match(o.oldstuff_content)))
  return ok({ help, activity, job, company, article, oldstuff })
})

// ---------------- 评论 / 回复 ----------------
export const getComment = (content_id) => delay().then(() => {
  const list = DB.comments.filter((c) => c.content_id === content_id)
  return { ...ok(list, list.length) }
})

export const setComment = (params) => delay().then(() => {
  const u = getCurrentUser()
  DB.comments.push({
    comment_id: 'cm' + Date.now(), content_id: params.content_id, user_id: u.user_id,
    comment_content: params.comment_content, comment_createtime: Date.now(), comment_favour_num: 0,
    comment_state: 1, comment_istop: 0, ispublic: 1, admin: 'admin',
    nickname: u.nickname, avatar: u.avatar, qq: u.qq, mail: u.mail, synopsis: u.synopsis,
    username: u.username, realstate: u.realstate, child: []
  })
  return ok({})
})

export const getReply = (comment_id) => delay().then(() => {
  const c = DB.comments.find((x) => x.comment_id === comment_id)
  return ok((c && c.child) || [])
})

export const setReply = (params) => delay().then(() => {
  const u = getCurrentUser()
  const c = DB.comments.find((x) => x.comment_id === params.comment_id)
  if (c) {
    c.child.push({
      reply_id: 'r' + Date.now(), comment_id: params.comment_id, user_id: u.user_id,
      reply_content: params.comment_content, tousernickname: params.tousernickname || '', touserid: params.touserid || '',
      createtime: Date.now(), reply_state: 1, reply_istop: 0, ispublic: 1, admin: 'admin', nickname: u.nickname
    })
  }
  return ok({})
})

// ---------------- 消息通知 ----------------
export const getNotice = (params) => delay().then(() => {
  const u = getCurrentUser()
  const list = DB.notices.filter((n) => n.user_to === u.user_id)
  const unread = list.filter((n) => n.state === 0).length
  if (params && params.num === 1) return ok({ count: unread })
  return ok({ count: unread, num: list.length, list })
})

export const changeNotice = (params) => delay().then(() => {
  if (params.change === 'changeall') DB.notices.forEach((n) => { n.state = 1 })
  if (params.change === 'deleteall') DB.notices.splice(0, DB.notices.length)
  if (params.change === 'change') { const n = DB.notices.find((x) => x.notice_id === params.notice_id); if (n) n.state = 1 }
  if (params.change === 'delete') { const i = DB.notices.findIndex((x) => x.notice_id === params.notice_id); if (i >= 0) DB.notices.splice(i, 1) }
  return ok({})
})

// ---------------- 认证 / 登录 ----------------
export const registered = (params) => delay().then(() => {
  const exists = DB.users.some((u) => u.username === params.username)
  if (exists) return { state: { type: 'ERROR_PARAMS_EXIST', msg: '账户名重复' } }
  DB.users.push({
    user_id: 'u-' + Date.now(), username: params.username, password: params.password, nickname: params.username,
    realname: '', studentid: '', studentcard: [], realstate: 1, avatar: '', qq: '', mail: '', synopsis: '',
    phone: '', companyname: '', companyimg: [], companystate: 1, user_state: '1', user_createtime: Date.now(), activationdate: 0
  })
  return ok({})
})

export const login = (params) => delay().then(() => {
  const u = DB.users.find((x) => x.username === params.username && x.password === params.password)
  if (!u) return err('用户名或密码错误')
  if (u.user_state === '0') return { state: { type: 's', msg: '账号因不良行为被限制登录' }, data: { activationdate: u.activationdate } }
  const { password, ...userinfo } = u
  return ok({ userinfo, token: 'mock-jwt-token-' + u.user_id })
})

export const logout = () => {
  localStorage.removeItem('luffy_jwt_token')
  localStorage.removeItem('userinfo')
  return Promise.resolve(ok({}))
}

// ---------------- 个人中心：用户信息 ----------------
export const getUser = () => delay().then(() => {
  const u = getCurrentUser()
  return ok({ ...u, studentcard: JSON.stringify(u.studentcard), companyimg: JSON.stringify(u.companyimg) })
})

export const updateUser = (params) => delay().then(() => {
  const u = getCurrentUser()
  const data = { ...params }
  if (data.studentcard) data.studentcard = JSON.parse(data.studentcard)
  if (data.companyimg) data.companyimg = JSON.parse(data.companyimg)
  if (data.m === 'user') {
    Object.assign(u, { avatar: data.avatar, nickname: data.nickname, qq: data.qq, mail: data.mail, phone: data.phone, synopsis: data.synopsis })
  } else if (data.m === 'student') {
    Object.assign(u, { realname: data.realname, studentid: data.studentid, studentcard: data.studentcard, realstate: 2 })
  } else if (data.m === 'company') {
    Object.assign(u, { companyname: data.companyname, companyimg: data.companyimg, companystate: 2 })
  }
  return ok({ userinfo: { ...u } })
})

export const getUserNumbering = () => delay().then(() => {
  const u = getCurrentUser()
  const cnt = (arr) => arr.filter((x) => x.user_id === u.user_id).length
  return ok({
    help: cnt(DB.helps), activity: cnt(DB.activities), article: cnt(DB.articles),
    job: cnt(DB.jobs), oldstuff: cnt(DB.oldstuffs)
  })
})

// ---------------- 个人中心：问答 ----------------
export const getMyHelpList = (params) => delay().then(() => {
  const u = getCurrentUser()
  const list = DB.helps.filter((h) => h.user_id === u.user_id)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})
export const getHelpDetails = (id) => delay().then(() => ok(DB.helps.find((x) => x.help_id === id)))
export const createHelp = (form) => delay().then(() => {
  const u = getCurrentUser()
  DB.helps.unshift({
    help_id: 'h' + Date.now(), user_id: u.user_id, help_title: form.help_title, help_tag: form.help_tag,
    help_lable: form.help_lable, help_content: form.help_content, help_img: '', createtime: Date.now(),
    updatetime: Date.now(), help_favour_num: 0, help_read_num: 0, help_state: 0, help_istop: 0,
    ispublic: 0, admin: '', nickname: u.nickname
  })
  return ok({})
})
export const updateHelp = (form) => delay().then(() => {
  const h = DB.helps.find((x) => x.help_id === form.id)
  if (h) Object.assign(h, { help_title: form.help_title, help_tag: form.help_tag, help_lable: form.help_lable, help_content: form.help_content, updatetime: Date.now() })
  return ok({})
})
export const deleteHelp = (help_id) => delay().then(() => {
  const i = DB.helps.findIndex((x) => x.help_id === help_id)
  if (i >= 0) DB.helps.splice(i, 1)
  return ok({})
})

// ---------------- 个人中心：活动 ----------------
export const getMyActivityList = (params) => delay().then(() => {
  const u = getCurrentUser()
  const list = DB.activities.filter((a) => a.user_id === u.user_id)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})
export const getActivityDetails = (id) => delay().then(() => {
  const a = DB.activities.find((x) => x.activity_id === id)
  return ok({ ...a, activity_impose: a.activity_impose === 'true' })
})
export const createActivity = (form) => delay().then(() => {
  const u = getCurrentUser()
  DB.activities.unshift({
    activity_id: 'ac' + Date.now(), user_id: u.user_id, activity_title: form.activity_title,
    activity_lable: form.activity_lable, activity_type: form.activity_type, activity_locale: form.activity_locale,
    activity_content: form.activity_content, activity_img: '', createtime: Date.now(),
    activity_statetime: form.activity_statetime, activity_endtime: form.activity_endtime,
    updatetime: Date.now(), activity_favour_num: 0, activity_num: form.activity_num, activity_read_num: 0,
    activity_state: 0, activity_istop: 0, ispublic: 0, admin: '', activity_impose: String(form.activity_impose),
    nickname: u.nickname
  })
  return ok({})
})
export const updateActivity = (form) => delay().then(() => {
  const a = DB.activities.find((x) => x.activity_id === form.id)
  if (a) Object.assign(a, { activity_title: form.activity_title, activity_lable: form.activity_lable, activity_type: form.activity_type, activity_locale: form.activity_locale, activity_content: form.activity_content, activity_statetime: form.activity_statetime, activity_endtime: form.activity_endtime, activity_num: form.activity_num, updatetime: Date.now() })
  return ok({})
})
export const deleteActivity = (activity_id) => delay().then(() => {
  const i = DB.activities.findIndex((x) => x.activity_id === activity_id)
  if (i >= 0) DB.activities.splice(i, 1)
  return ok({})
})
export const getMyJoins = (content_id) => delay().then(() => {
  const list = DB.joins.filter((j) => j.content_id === content_id)
  return ok(list.map((j) => {
    const u = DB.userMap[j.user_id]
    return { ...j, username: u.username, nickname: u.nickname, qq: u.qq, phone: u.phone }
  }))
})
export const getJoinsList = (type) => delay().then(() => {
  const u = getCurrentUser()
  const list = DB.joins.filter((j) => j.type === type && j.user_id === u.user_id)
  return ok(list.map((j) => {
    if (type === 'activitycontent') {
      const a = DB.activities.find((x) => x.activity_id === j.content_id)
      return { ...j, activity_id: j.content_id, activity_title: a ? a.activity_title : '', activity_lable: a ? a.activity_lable : '' }
    }
    const o = DB.oldstuffs.find((x) => x.oldstuff_id === j.content_id)
    return { ...j, oldstuff_id: j.content_id, oldstuff_name: o ? o.oldstuff_name : '', oldstuff_price: o ? o.oldstuff_price : '' }
  }))
})
export const deleteJoin = (id) => delay().then(() => {
  const i = DB.joins.findIndex((x) => x.join_id === id)
  if (i >= 0) DB.joins.splice(i, 1)
  return ok({})
})

// 活动公告（个人中心发布）
export const setAnnouncement = (params) => delay().then(() => {
  if (!DB.announcements[params.content_id]) DB.announcements[params.content_id] = []
  DB.announcements[params.content_id].push({
    announcement_id: 'an' + Date.now(), announcement_name: params.announcement_name,
    announcement_content: params.announcement_content, announcement_createtime: Date.now()
  })
  return ok({})
})

// ---------------- 个人中心：二手 ----------------
export const getMyOldstuffList = (params) => delay().then(() => {
  const u = getCurrentUser()
  const list = DB.oldstuffs.filter((o) => o.user_id === u.user_id)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})
export const getOldstuffDetails = (id) => delay().then(() => ok(DB.oldstuffs.find((x) => x.oldstuff_id === id)))
export const createOldstuff = (form) => delay().then(() => {
  const u = getCurrentUser()
  DB.oldstuffs.unshift({
    oldstuff_id: 'o' + Date.now(), user_id: u.user_id, oldstuff_img: form.oldstuff_img,
    oldstuff_name: form.oldstuff_name, oldstuff_price: Number(form.oldstuff_price), oldstuff_lable: form.oldstuff_lable,
    oldstuff_content: form.oldstuff_content, createtime: Date.now(), updatetime: Date.now(),
    oldstuff_favour_num: 0, oldstuff_read_num: 0, oldstuff_state: 0, oldstuff_istop: 0, ispublic: 0,
    admin: '', nickname: u.nickname
  })
  return ok({})
})
export const updateOldstuff = (form) => delay().then(() => {
  const o = DB.oldstuffs.find((x) => x.oldstuff_id === form.id)
  if (o) Object.assign(o, { oldstuff_img: form.oldstuff_img, oldstuff_name: form.oldstuff_name, oldstuff_price: Number(form.oldstuff_price), oldstuff_lable: form.oldstuff_lable, oldstuff_content: form.oldstuff_content, updatetime: Date.now() })
  return ok({})
})
export const deleteOldstuff = (oldstuff_id) => delay().then(() => {
  const i = DB.oldstuffs.findIndex((x) => x.oldstuff_id === oldstuff_id)
  if (i >= 0) DB.oldstuffs.splice(i, 1)
  return ok({})
})

// ---------------- 个人中心：文章 ----------------
export const getMyArticleList = (params) => delay().then(() => {
  const u = getCurrentUser()
  const list = DB.articles.filter((a) => a.user_id === u.user_id)
  const r = paginate(list, params)
  return { ...ok(r.data, r.count) }
})
export const getArticleDetails = (id) => delay().then(() => ok(DB.articles.find((x) => x.article_id === id)))
export const createArticle = (form) => delay().then(() => {
  const u = getCurrentUser()
  DB.articles.unshift({
    article_id: 'a' + Date.now(), user_id: u.user_id, article_title: form.article_title,
    article_introduction: form.article_introduction, article_lable: form.article_lable,
    article_content: form.article_content, article_createtime: Date.now(), article_updatetime: Date.now(),
    article_favour_num: 0, article_read_num: 0, article_state: 0, article_istop: 0, ispublic: 0,
    admin: '', nickname: u.nickname
  })
  return ok({})
})
export const updateArticle = (form) => delay().then(() => {
  const a = DB.articles.find((x) => x.article_id === form.id)
  if (a) Object.assign(a, { article_title: form.article_title, article_introduction: form.article_introduction, article_lable: form.article_lable, article_content: form.article_content, article_updatetime: Date.now() })
  return ok({})
})
export const deleteArticle = (article_id) => delay().then(() => {
  const i = DB.articles.findIndex((x) => x.article_id === article_id)
  if (i >= 0) DB.articles.splice(i, 1)
  return ok({})
})

// ---------------- 个人中心：公司 / 岗位 ----------------
export const getWebCompany = () => delay().then(() => {
  const u = getCurrentUser()
  const company = DB.companies.find((c) => c.user_id === u.user_id) || null
  const joblist = company ? DB.jobs.filter((j) => j.company_id === company.company_id) : []
  return ok({ company, joblist })
})
export const changeWebCompany = (form) => delay().then(() => {
  const u = getCurrentUser()
  let c = DB.companies.find((x) => x.user_id === u.user_id)
  if (!c) {
    c = { company_id: 'cp' + Date.now(), user_id: u.user_id, company_name: form.company_name, company_scale: form.company_scale, company_content: form.company_content, company_mail: form.company_mail, company_createtime: Date.now(), company_updatetime: Date.now(), company_favour_num: 0, company_read_num: 0, company_state: 0, company_istop: 0, company_ispublic: 0, admin: '' }
    DB.companies.push(c)
  } else {
    Object.assign(c, { company_name: form.company_name, company_scale: form.company_scale, company_content: form.company_content, company_mail: form.company_mail, company_updatetime: Date.now() })
  }
  return ok({})
})
export const createJob = (form) => delay().then(() => {
  const u = getCurrentUser()
  DB.jobs.unshift({
    job_id: 'j' + Date.now(), user_id: u.user_id, company_id: form.company_id, job_name: form.job_name,
    job_salary: form.job_salary, job_num: form.job_num, job_lable: form.job_lable, job_content: form.job_content,
    job_createtime: Date.now(), job_updatetime: Date.now(), job_favour_num: 0, job_read_num: 0,
    job_state: 0, job_istop: 0, ispublic: 0, admin: '', company_name: ''
  })
  return ok({})
})
export const deleteJob = (job_id) => delay().then(() => {
  const i = DB.jobs.findIndex((x) => x.job_id === job_id)
  if (i >= 0) DB.jobs.splice(i, 1)
  return ok({})
})

// ---------------- 客服 ----------------
export const createFankui = (form) => delay().then(() => {
  DB.kefus.fankui.unshift({ fankui_id: 'fk' + Date.now(), fankui_content: form.fankui_content, fankui_user: form.fankui_user, fankui_createtime: Date.now(), fankui_state: 0, admin: '' })
  return ok({})
})
export const createJubao = (form) => delay().then(() => {
  DB.kefus.jubao.unshift({ jubao_id: 'jb' + Date.now(), jubao_content: form.jubao_content, jubao_user: form.jubao_user, jubao_img: JSON.parse(form.jubao_img || '[]'), jubao_url: form.jubao_url, jubao_createtime: Date.now(), jubao_state: 0, admin: '', result: '' })
  return ok({})
})
export const getJubaoContent = (id) => delay().then(() => ok(DB.kefus.jubao.find((x) => x.jubao_id === id)))
export const createShensu = (form) => delay().then(() => {
  DB.kefus.shensu.unshift({ shensu_id: 'ss' + Date.now(), shensu_content: form.shensu_content, shensu_user: form.shensu_user, shensu_jubao_id: form.shensu_jubao_id, shensu_createtime: Date.now(), shensu_state: 0, admin: '' })
  return ok({})
})
